import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Heading, Panel, Separator, Text } from "@nju/ui";

export function ChangePasswordError() {
  return (
    <Panel>
      <div className="flex flex-col items-center">
        <Heading font="ttfirs" tone="neutral" variant="h3" weight="bold">
          coś poszło nie tak
        </Heading>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="exclamation-circle-incircle"
        />
        <Separator size="xs" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          Wystąpił niespodziewany błąd techniczny, spróbuj jeszcze raz.
        </Text>
      </div>
      <Separator size="xs" tone="invisible" />
      <div className="flex justify-center only-mobile:flex-col-reverse">
        <Link
          href={portalRoutes.mojeKonto.index.get({ mode: "ftth" })}
          passHref={true}
        >
          <A
            className="only-mobile:mt-3 from-tablet:mr-4"
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
            variant="secondary"
          >
            anuluj
          </A>
        </Link>
        <Link
          href={portalRoutes.mojeKonto.mojProfil.index.get()}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
            variant="primary"
          >
            spróbuj ponownie
          </A>
        </Link>
      </div>
    </Panel>
  );
}
